export default __webpack_public_path__ + "static/media/ico-09.4f02c501.png";